var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"reportrange",staticClass:"date-range-picker"},[_c('span',{staticClass:"btn btn-sm border"},[_c('i',{staticClass:"fa fa-calendar-days"}),_vm._v(_vm._s(_vm.dateRangeText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }